import { CheckIcon } from "@heroicons/react/24/outline";
import { Button, Modal } from "../ui";

// The dialog that creates a draft call around its form: Cancel throws the draft away, closing keeps it
export default function CreateDraftDialog({ open, title, formId, submitting, onClose, onCancel, onSubmit, children }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      dismissible={!submitting}
      size="xl"
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
          <Button type="submit" form={formId} loading={submitting} icon={<CheckIcon className="h-4 w-4" />}>
            Create draft
          </Button>
        </>
      }
    >
      <form id={formId} onSubmit={onSubmit} noValidate className="flex flex-col gap-5">
        {children}
      </form>
    </Modal>
  );
}
